import { Injectable } from "@angular/core";
import { ConfigService } from "../config/config.service";
import { Navigator } from "src/app/components/menu/navigator";
import { LogoutService } from "../logout/logout.service";
import { HttpClient } from "@angular/common/http";
import { MenuItemPreProcessor } from "../cashier/menu-item-pre-processor-helper.service";
import { WithdrawalService } from "../cashier/withdrawal.service";
import { MenuController } from "@ionic/angular";
import { LoyaltyProgramProvider } from "../loyalty-program/loyalty-program.service";
import { firstValueFrom, ReplaySubject, Subject } from "rxjs";
import { isUndefined, isValidJSON, sortBy } from "../codeUtils";
import { WebcontentService } from "../webcontent/webcontent.service";
import { ResponsibleGamingService } from "../responsible-gaming-service/responsible-gaming.service";
import { CashierService } from "../cashier/cashier.service";
import { CashierContentService } from "../cashier/cashier-content.service";
import { EventsService } from "../event/event.service";

@Injectable({
  providedIn: "root",
})
export class SidemenuService {
  public menuOpts: any;
  public menuItemsSubject: Subject<[]>;

  constructor(
    private cashierService: CashierService,
    private cashierContentService: CashierContentService,
    private config: ConfigService,
    private http: HttpClient,
    private loyaltyProgramProvider: LoyaltyProgramProvider,
    private logoutService: LogoutService,
    private menuCtrl: MenuController,
    private navigator: Navigator,
    private responsibleGamingProvider: ResponsibleGamingService,
    private withdrawService: WithdrawalService,
    private webContentService: WebcontentService,
    private eventsService: EventsService
  ) {
    this.menuItemsSubject = new ReplaySubject(1);
  }

  public async getSidemenuData(): Promise<any> {
    const siteMenuFile = this.config.getConfig().SITE_MENU_FILE;

    const value = this.http.get<any[]>(siteMenuFile);
    const menuOpts: any[] = await firstValueFrom(value);

    if (Array.isArray(menuOpts)) {


      const menuItemPreProcessor = new MenuItemPreProcessor(
        this.withdrawService,
        this.loyaltyProgramProvider,
        this.config,
      );

      menuOpts.forEach((menuItem) => {
        menuItemPreProcessor.menuItemPreProcessing(menuItem);
      });
    }
    this.menuOpts = menuOpts;
    return this.menuOpts;
  }

  public getProductVerticals(): any {
    return this.config?.getConfig()?.PRODUCTVERTICALS;
  }

  reIterateMenu() {
    const menuItemPreProcessor = new MenuItemPreProcessor(
      this.withdrawService, this.loyaltyProgramProvider, this.config
    );

    const filteredMenuOpts = this.menuOpts.filter(() => {
      return true;
    })

    filteredMenuOpts.forEach((menuItem) => {
      menuItemPreProcessor.menuItemPreProcessing(menuItem);
    });

    this.setMenuData(filteredMenuOpts);
    return filteredMenuOpts;
  }

  public sidemenuLogout(): any {
    this.closeMenu();
    return this.logoutService.callLogout();
  }

  setMenuData(data) {
    this.menuItemsSubject.next(data);
  }

  public goToTab(vertical?: any): any {
    const code: string = vertical?.product_vertical_code ?? '';
    this.eventsService.publish("event:sidemenu:tab:selection", code);
    switch (code) {
      case 'CASINO':
        this.navigator.toCasino(true);
        break;
      case 'SPORTS':
        this.navigator.toSports(true);
        break;
      case 'LIVE_DEALER':
        this.navigator.toLiveDealer(true);
        break;
      default:
        this.navigator.toHomePage(true);
        break;
    }
   
    return this.closeMenu();

  }

  public navigateToAPage(pageName, params?): any {
     if (pageName === "main-menu") {
      this.menuCtrl.open('menu');
    }else{
      this.navigator.navigateTo(pageName, {}, params);
    }
    return this.closeMenu();
  }

  public getExternalLinks(): any[] {
    let links = this.config?.getExternalLinks() ?? [];
    links = links.payload;

    if (!Array.isArray(links)) {
      if (typeof links === 'object') {
        links = Object.values(links);
      } else {
        links = [];
      }
    }

    return links.map(
      link => {
        link.active = false;
        return link;
      }
    ).filter(
      link => link.isHamburgerMenu == "1"
    ).sort(sortBy('lobbyNavBarPosition'));
  }

  public getHomeConfig(): any {
    const defaultHomeConfig: any = { "enabled": true, "url": "home", "title": "home", "icon_name": "home.svg" };
    const homeConfig = this.config.getExternalLinks().payload.filter(link => link?.code == "homepage")[0]?.url;
    if (isValidJSON(homeConfig) && !isUndefined(homeConfig)) return JSON.parse(homeConfig);
    return defaultHomeConfig;
  }

  public openExternalLinks(link: any): any {
    const stub: string = link?.url;
    this.webContentService.updateExternalLink(stub);
    this.navigator.toTab("c", false, stub);
    return this.closeMenu();
  }

  public onDeposit(): any {
    this.responsibleGamingProvider.getAllPendingLimit().subscribe(
      (response: any) => {
        if (response.payload.length !== 0) {
          this.navigator.navigateTo('LimitConfirmationComponent', { forceModal: true }, { callBackFn: () => { this.navigator.navigateTo("DepositMainComponent"); } });
        } else {
          return this.cashierService.getActiveTypesCategories({ include_types: false }).subscribe({
            next: (response) => {
              const data = response?.payload?.filter(
                (item) => item?.is_default == true
              );
              const lastDeposit = data.length > 0 ? data[0].code : null;
              const pageToRedirect = this.cashierContentService.getVendorPage(lastDeposit);

              !!pageToRedirect ? this.navigator.navigateTo(pageToRedirect, {}, { navigateBackPage: "sidemenu" }) : this.navigator.navigateTo("DepositMainComponent", { navigateBackPage: "sidemenu" });
            },
            error: (error) => {
              console.error('Sideeny Deposit error: ', error)
              this.navigator.navigateTo("DepositMainComponent")
            },
            complete: () => {
              this.closeMenu();
            }
          });
        }
      });
  }

  private closeMenu = () => this.menuCtrl.close();

}
